// ----
// JS for Captcha Widgets
// ----

var SCM = SCM || {};

SCM.Captcha = (function () {

    var _simpleCaptchaResponseIdentifier = '#txtCaptchaInputId';
    var _googleReCaptchaResponseIdentifier = '.g-recaptcha-response'; 

    return {
        Init : init,
        GetCaptchaResponse : getCaptchaResponse,
		GetCaptchaInfo : getCaptchaInfo,
        ResetCaptcha : resetCaptcha
    };

    // initializes the gRecaptcha v2 js
    // returns true if init succeeds, false otherwise (helps with debugging)
    function init(captchaModelSiteKey) {
        if (window.grecaptcha !== undefined && window.grecaptcha !== null) {
            window.grecaptcha.render('captcha', {'sitekey': captchaModelSiteKey, 'error-callback': _handleRecaptchaRenderingError });

            return true;
        }

        return false;
    }
    function _handleRecaptchaRenderingError() {
        let ajaxUrl = '/ThirdParty/ReCaptcha/Captcha_FallBackToSimpleCaptcha';
        SCM.Ajax.get(ajaxUrl) 
            .expectHtml()
            .then(_handleSuccess)
            .catch(console.error);
    }

    function _handleSuccess(ajaxResult) {
        let $recaptchaWidgetElem = $('.widget-ReCaptcha');
        if (ajaxResult != undefined && ajaxResult.length) {
            $recaptchaWidgetElem.replaceWith(ajaxResult);
        }
    }
        
    
    // returns the detected captcha response, empty string otherwise
    function getCaptchaResponse($formContainer) {
        
        var element = $formContainer.find(_simpleCaptchaResponseIdentifier);

        if (element.is(':visible')) {
            return element.val();
        }
        
        element = $formContainer.find(_googleReCaptchaResponseIdentifier);

        if (element.length) {
            return element.val();
        }

        return '';
    }
	
	//returns more detailed captcha information, needed for some custom behaviors
	function getCaptchaInfo() {
		
		var useV3 = $('#recaptchaUseV3').val();
		var captchaToken = getCaptchaToken(_googleReCaptchaResponseIdentifier);
		
		return {
            ReCaptchaV3Token: (useV3 === 'True') ? captchaToken : '',
            ReCaptchaV2Token: (useV3 === 'False') ? captchaToken : '',
            SimpleCaptchaToken: getCaptchaToken(_simpleCaptchaResponseIdentifier),
            ReCaptchaWidgetControlId: getCaptchaToken('#recaptchaWidgetInstance'),
            UserEmail: $('.js-captchaUserEmail').val()
        };
	}
	
	function getCaptchaToken(tokenSelector) {
        var token = $(tokenSelector).val();
        if (typeof token === 'undefined' || token.length == 0) {
            return '';
        }
        return token;
    }
    
    // resets the google captcha (if it exists)
    function resetCaptcha($formContainer) {
        var element = $formContainer.find(_googleReCaptchaResponseIdentifier);

        if (element.length) {
            // grecaptcha is loaded by ajax response from third party
            // see ReCaptcha.cshtml 
            window.grecaptcha.reset();
        }
    }

})();